import React, { useContext, useEffect } from "react";
import FilterPopup from "../FilterPopup";
import SelectableList from "../components/SelectableList";
import { type ArtistProfileFilterType, type ArtistProfileFilterOption, getOption, ArtistProfileOptions, DefaultArtistProfileFilter, initialArtistProfileFilter } from "./FilterTypes/ArtistProfileFilterType";
import { FilterContext } from "../FilterContext";

const ArtistProfileFilter = () => {
  const title = RESX.Company.Profile;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  const reset = (): ArtistProfileFilterType => ({
    option: getOption(DefaultArtistProfileFilter)
  });
  register("artistProfile", {
    getTitle: () => title,
    renderSelection: (value) => <>{value.option.label}</>,
    hasValue: (value) => value.option.value !== DefaultArtistProfileFilter,
    reset,
    areEqual: (a, b) => a.option.value === b.option.value
  });
  useEffect(() => {
    setInitialValue("artistProfile", reset());
  }, []);

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);
  const [selectedOption, setSelectedOption] = React.useState(initialArtistProfileFilter.option);

  const onChange = (option: ArtistProfileFilterOption) => {
    if (selectedOption?.value === option.value) {
      setValue("artistProfile", reset());
      setSelectedOption(undefined);
    } else {
      setSelectedOption(option);
      setValue("artistProfile", { option });
    }
    onPopupClose();
  };

  const onPopupClose = () => {
    setPopupOpen(false);
  };

  const onPopupOpen = () => {
    setSelectedOption(getValue("artistProfile").option);
    setPopupOpen(true);
  };

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      width={272}
      content={<div>
        <SelectableList
          noSearch
          items={ArtistProfileOptions}
          selectedItems={selectedOption ? [selectedOption] : []}
          onItemToggled={onChange}
          getId={opt => opt.value}
          getName={opt => opt.label}
        />
      </div>}

      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default ArtistProfileFilter;